import { defineRecipe } from '@chakra-ui/react';

export const badgeRecipe = defineRecipe({
	className: 'chakra-badge',
	base:      {
		display:            'inline-flex',
		alignItems:         'center',
		borderRadius:       'l2',
		gap:                '1',
		fontWeight:         'medium',
		fontVariantNumeric: 'tabular-nums',
		whiteSpace:         'nowrap',
		userSelect:         'none',
	},
	variants: {
		mtgFinish: {
			foil:    { bg: 'yellow.500' },
			nonfoil: { bg: 'green.500' },
			etched:  { bg: 'blue.500' },
			signed:  { bg: 'purple.500' },
		},
		legality: {
			legal:      { bg: 'green.500' },
			banned:     { bg: 'red.500' },
			restricted: { bg: 'yellow.500' },
		},
		order: {
			pending:   { bg: 'blue.500' },
			confirmed: { bg: 'green.500' },
			completed: { bg: 'green.500' },
			cancelled: { bg: 'red.500' },
		},
		variant: {
			solid: {
				bg:            'colorPalette.solid',
				color:         'colorPalette.contrast',
				textTransform: 'uppercase',
			},
			subtle: {
				bg:    'colorPalette.subtle',
				color: 'colorPalette.fg',
			},
			outline: {
				color:       'colorPalette.fg',
				shadow:      'inset 0 0 0px 1px var(--shadow-color)',
				shadowColor: 'colorPalette.muted',
			},
			surface: {
				bg:          'colorPalette.subtle',
				color:       'colorPalette.fg',
				shadow:      'inset 0 0 0px 1px var(--shadow-color)',
				shadowColor: 'colorPalette.muted',
			},
			plain: { color: 'colorPalette.fg' },
		},
		size: {
			xs: {
				textStyle:  'p5',
				px:         '6px',
				minH:       '4',
				fontWeight: 'bold',
			},
			sm: {
				textStyle:  'p5',
				px:         '8px',
				minH:       '5',
				fontWeight: 'bold',
			},
			md: {
				textStyle:  'p4',
				px:         '12px',
				minH:       '6',
				fontWeight: 'bold',
			},
			lg: {
				textStyle:  'p4',
				px:         '16px',
				minH:       '7',
				fontWeight: 'bold',
			},
		},
	},
	defaultVariants: {
		variant: 'solid',
		size:    'md',
	},
});
